<template>
  <div>
    <Form :model="formData">
      <FormItem :labelWidth="80"
                :label="$t('erp.distribution.disassemble_type_label', { defaultValue: '拆解类型' }) + ':'">
        <RadioGroup size="small"
                    v-model="formData.splitType">
          <Radio style="font-size: 12px;"
                 :label="1">{{$t('erp.distribution.disassemble_type_2', { defaultValue: '按仓库拆（相同仓库的一行或多行生成一个配货单）' })}}</Radio>
          <Radio style="font-size: 12px;"
                 :label="0">{{$t('erp.distribution.disassemble_type_1', { defaultValue: '按行拆（一行生成一个配货单）' })}}</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem :labelWidth="80"
                :label="$t('erp.distribution.disassemble_rule', { defaultValue: '拆解规则' }) + ':'">
        <RadioGroup size="small"
                    v-model="formData.checkType">
          <Radio style="font-size: 12px;"
                 :label="1">{{$t('erp.distribution.disassemble_valid_stock', { defaultValue: '库存满足才拆' })}}</Radio>
          <Radio style="font-size: 12px;"
                 :label="0">{{$t('erp.distribution.disassemble_not_valid_stock', { defaultValue: '不验证库存（库存不足也可以拆解，拆解后配货单需要手动提交）' })}}</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <Table class="margin-top-20"
           :loading="loading"
           :columns="columns"
           :data="formList"
           size="small"
           ref="table"
           border></Table>
    <div class="color-error text-center">{{$t('erp.b2c.order_disassemble_tip', { defaultValue: '拆解订单只对ERPSKU的数量进行拆解，组合产品的产品行信息（SellerSKU和数量）保持跟原订单一样' })}}</div>
    <footer class="text-right margin-top-10">
      <Button type="primary"
              @click="submit">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</Button>
      <Button class="margin-left-10"
              @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
    </footer>
    <Alert v-if="alertProps.show"
           v-bind="alertProps"
           @on-alert-close="handleCloseModal"></Alert>
    <vModal v-model="operate.show"
            v-bind="operate">
      <div class="modal-tip">{{$t('erp.b2c.order_confirm_tip', { defaultValue: '拆解成功后，配货单会自动进行处理，请确认！' })}}</div>
      <div class="modal-button-container">
        <Button class="modal-button"
                type="primary"
                @click="confirm">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</Button>
      </div>
    </vModal>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import {
  HttpdismantlingOrderRead,
  HtttdismantlingOrder
} from '@/service/boss/b2corder'
import Alert from './alert';
export default {
  props: ['id'],
  components: {
    Alert
  },
  data () {
    return {
      loading: false,
      datalist: [],
      operate: {
        show: false
      },
      alertProps: {
        show: false
      },
      formData: {
        splitType: 1,
        checkType: 1
      }
    }
  },
  computed: {
    ...mapState('boss', ['warehouseList']),
    warehousesAll () {
      return this.warehouseList.filter(function (item) {
        return item.warehouseType !== 4 && item.active == 1
      })
    },
    formList () {
      return this.datalist || []
    },
    columns () {
      const _this = this
      return [
        {
          title: 'Seller SKU',
          key: 'sellerSku',
          render (h, { row, index }) {
            return <div>{row.sellerSku ? row.sellerSku : '--'}</div>
          }
        }, {
          title: 'ERP SKU',
          key: 'erpSku',
          render (h, { row, index }) {
            return <div>{row.erpSku}</div>
          }
        }, {
          title: 'ERP SKU' + this.$t('erp.b2c.quantity', { defaultValue: '数量' }),
          key: 'qty',
          width: 150,
          render (h, { row, index }) {
            if (row.$Edit) {
              return h('InputNumber', {
                props: {
                  size: 'small',
                  min: 1,
                  value: row.qty
                },
                on: {
                  'input': (event) => {
                    row.qty = event
                    // console.log(event)
                    _this.datalist[index] = row
                  }
                },
              })
            } else {
              return <div>{row.qty}</div>
            }
          }
        }, {
          title: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
          key: 'orgWarehouseId',
          width: 230,
          render (h, { row, index }) {
            if (row.$Edit) {
              return h('Select', {
                props: {
                  value: _this.datalist[index].orgWarehouseId,
                  filterable: true,
                  clearable: true,
                },
                on: {
                  'on-change': (value) => {
                    _this.datalist[index].orgWarehouseId = value
                  }
                },
              },
                _this.warehousesAll.map((json) => {
                  // console.log(json)
                  return h('Option', {
                    props: {
                      value: json.id,
                      label: json.title + '(' + json.code + ')'
                    }
                  });
                })
              )
            } else {
              return <div>{row.orgWarehouseId}</div>
            }
          }
        }, {
          title: this.$t('global.common.operation', { defaultValue: '操作' }),
          width: 140,
          render (h, { row, index }) {
            if (row.$Emitadd) {
              return h('div', [
                h('Button', {
                  props: {
                    type: "primary",
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      _this.changeEdit(row, index)
                    }
                  }
                }, _this.$t('global.common.operation_add', { defaultValue: '增加' }))
              ])
            } else {
              return h('div', [
                h('Button', {
                  props: {
                    type: "error",
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      _this.comremove(index)
                    }
                  }
                }, _this.$t('global.common.delete', { defaultValue: '删除' }))
              ])

            }
          }
        },]
    },
  },
  created () {
    this.getdisassmble()
  },
  methods: {
    handleCloseModal () {
      this.alertProps.show = false;
    },
    getdisassmble () {
      HttpdismantlingOrderRead({
        orderId: this.id,
      }).then(res => {
        let resdata = res.data
        if (resdata == null) {
          resdata = []
        } else {
          resdata.map(item => {
            item.$Emitadd = true
            item.$Edit = true
          })
        }

        this.datalist = resdata
      }, err => {

      })
    },
    changeEdit (row, index) {
      let itemdata = {
        sellerSku: row.sellerSku,
        erpSku: row.erpSku,
        itemId: row.itemId,
        itemProductId: row.itemProductId,
        qty: null,
        orgWarehouseId: null,
        $Emitadd: false,
        $Edit: true,
      }
      this.datalist.splice(index + 1, 0, itemdata)

    },
    comremove (index) {
      this.datalist.splice(index, 1);
    },
    cancel () {
      this.$emit('on-close')
    },
    submit () {
      // this.operate = {
      //     show: true,
      //     title: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
      //     showFooter: false
      // }
      this.alertProps = {
        show: true,
        title: this.$t('erp.b2c.operate_dismantling', { defaultValue: '拆解' }),
        desc: this.$t('erp.b2c.order_confirm_tip', { defaultValue: '拆解成功后，配货单会自动进行处理，请确认！' }),
        confirm: () => {
          this.confirm();
        }
      }
      // console.log(this.datalist)

    },
    confirm () {
      HtttdismantlingOrder({
        orderId: this.id,
        dismantlingOrder: this.datalist,
        splitType: this.formData.splitType,
        checkType: this.formData.checkType
      }).then(res => {
        this.loading = false
        this.$Message.success(res.message);
        this.cancel()
      }, err => {
        this.loading = false
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
        this.alertProps.show = false;
        // this.cancel()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-tip {
  color: #ed4014;
  font-size: 16px;
  margin: 15px 0;
}
.modal-button-container {
  text-align: center;
}
.modal-button {
  width: 100%;
  margin: 0 auto;
}
</style>
